module.exports = {
  customer: 'southampton',
  environment: 'production',
  isBetterCare: true,
  googleAnalyticsId: 'G-7MJSPZCLMW',
  robots: true,
  chatWidget: false,
  requirePostcode: false,

  app: {
    home: 'https://southampton.bettercare.org.uk'
  },
  serverBaseUrl: 'https://api-southampton.bettercare.org.uk',
  api: {
    baseUrl: 'https://api-southampton.bettercare.org.uk/internal/v1'
  },
  authGateway: 'https://account.southampton.bettercare.org.uk',
  loginServices: [
    {name: 'kerp'},
    {name: 'phone'},
    {name: 'google', postLogoutUrl: 'https://accounts.google.com/Logout'},
    {name: 'facebook'},
    {name: 'agent'},
    {name: 'referenceNumber'}
  ],
  ui: {
    showJobSearchJournal: false,
    showOfflineForms: true,
    showTestingTools: true,
    showAssessmentMutators: false,
    showDraftForms: true,
    restrictions: {
      applications: false
    }
  },
  airbrake: {
    enabled: true,
    projectId: 131082,
    projectKey: 'facc9a060872b357453b677f15d319e3'
  }
};
